var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({
        color: (_vm.is_inverted) ? 'white' : 'black',
        paddingTop: (_vm.top) ? '0px' : '25%',
        top: (_vm.top) ? _vm.top : '0',
    }),attrs:{"id":"navigation_left"}},[_c('i',{staticClass:"caret left icon"})])}
var staticRenderFns = []

export { render, staticRenderFns }